import { render } from "./detailList.vue?vue&type=template&id=37a4c4a6&scoped=true"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"

import "./detailList.vue?vue&type=style&index=0&id=37a4c4a6&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a4c4a6"]])

export default __exports__